import styled from 'styled-components';
import { StarIc } from '@dsch/dd-icons';

import { Link } from 'components/Toolkit/Button/Link';
import { media } from 'helpers/breakpoints';

import type { Variant } from 'components/PageWrappers/AdDetails/components/GoogleReviews/InfoTitleStarRating/InfoTitleStarRating.typed';

const RatingContainer = styled.div<{ variant?: Variant }>`
  ${({ theme, variant }) =>
    variant === 'LARGE' ? theme.fontSize.M14 : theme.fontSize.B12};
  display: flex;
  align-items: center;
  gap: 4px;
`;

const RatingGroup = styled.div`
  display: inline-block;
  vertical-align: middle;
`;

const Rating = styled.span<{ styleAsLink?: boolean }>`
  color: ${({ theme, styleAsLink }) =>
    styleAsLink ? theme.colors.BLUE : theme.colors.GREY_DARKER};
  font-weight: ${({ theme, styleAsLink }) =>
    styleAsLink ? theme.fontWeight.regular : theme.fontWeight.bold};

  ${media.large} {
    color: ${({ theme }) => theme.colors.GREY_DARKER};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }
`;

const MaxRating = styled.span<{ styleAsLink?: boolean }>`
  color: ${({ theme, styleAsLink }) =>
    styleAsLink ? theme.colors.BLUE : theme.colors.GREY};

  ${media.large} {
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    color: ${({ theme }) => theme.colors.GREY};
  }
`;

const SStarIc = styled(StarIc)<{ variant?: Variant }>`
  vertical-align: middle;
  margin-left: ${({ theme }) => theme.spacing.S4};

  ${media.large} {
    margin-left: ${({ theme, variant }) =>
      variant === 'LARGE' ? theme.spacing.S8 : theme.spacing.S4};
  }
`;

const SLink = styled(Link)`
  color: ${({ theme }) => theme.colors.BLUE};
  display: inline-block;
  cursor: pointer;

  ${media.large} {
    pointer-events: none;
    cursor: default;
  }
`;

export { RatingContainer, RatingGroup, Rating, MaxRating, SStarIc, SLink };
